import React, { Component } from 'react';
import { Layout } from 'antd';
import { YMaps } from 'react-yandex-maps';
import { withAsyncActions } from 'react-async-client';

import { YMAPS_TOKEN } from 'constants/yandexMap';
import { isMobile } from 'constants/screen';
import { getPhotoReportSettings } from 'actions/asyncActions';
import LeftMenu from './LeftMenu';
import Modals from '../../modals/Modals';
import { UserRoutes } from '../../Routes';
import Spinner from 'components/common/Spinner';

@withAsyncActions({
    getPhotoReportSettings: getPhotoReportSettings
        .withOptions({ dispatchOnMount: true })
})
export default class UserLayout extends Component {
    constructor() {
        super();

        this.state = {
            collapsed: isMobile(),
        };
    }

    handleCollapse = (state) => {
        this.setState(prev => (state ? state : { collapsed: !prev.collapsed }));
    }

    render() {
        const { collapsed } = this.state;
        const { meta } = this.props.getPhotoReportSettings;

        if (!meta.success && !meta.error) {
            return <Spinner />;
        }

        return (
            <YMaps query={{ apikey: YMAPS_TOKEN, coordorder: 'longlat', load: ['control.ZoomControl', 'geoObject.addon.balloon'] }}>
                <Layout className='user-layout ant-layout-has-sider'>
                    <LeftMenu handleCollapse={this.handleCollapse} collapsed={collapsed} />
                    <Layout className='layout-wrapper'>
                        <Layout.Content>
                            <div className='content-wrapper'>
                                <UserRoutes />
                            </div>
                        </Layout.Content>
                    </Layout>
                    <Modals />
                </Layout>
            </YMaps>
        );
    }
}
